import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/patients/components/PatientsFilters.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/patients/components/PatientsHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/patients/components/PatientsTable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/AppLayout.tsx");
